import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Edit from "@material-ui/icons/EditOutlined";
import { maybe } from "@saleor/misc";
import * as React from "react";

interface RemarksCellProps {
  order: any;
  onAddRemarks: (
    orderId: string,
    orderCode: string,
    orderOldRemarks?: string,
    orderOldRemarkId?: string
  ) => void;
}

const useStyles = makeStyles(
  theme => ({
    editButton: {
      border: "0px",
      padding: "0px"
    },
    remarks: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    },
    remarksCellContent: {
      display: "flex",
      flex: "none",
      flexDirection: "column",
      fontSize: "11px",
      width: "10em"
    },
    remarksCellContentText: {
      display: "flex",
      flex: "none",
      flexDirection: "column",
      width: "10em"
    },
    remarksContainer: {
      display: "flex",
      width: "15em"
    },
    toolTipTitle: {
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: 3,
      display: "-webkit-box",
      overflow: "hidden",
      width: "100%",
      [theme.breakpoints.down("sm")]: {
        display: "unset"
      }
    }
  }),
  { name: "RemarksCell" }
);

const RemarksCell: React.FC<RemarksCellProps> = props => {
  const { order, onAddRemarks } = props;
  const classes = useStyles(props);

  return (
    <>
      {maybe(
        () =>
          order?.orderFulfillmentRemarks &&
          order?.orderFulfillmentRemarks?.message
      ) ? (
        <div>
          <Tooltip
            placement="bottom"
            title={order?.orderFulfillmentRemarks?.message.slice(0, 250)}
            interactive
          >
            <div
              onClick={e => e.stopPropagation()}
              className={classes.remarksContainer}
            >
              <div className={classes.toolTipTitle}>
                <span>{order?.orderFulfillmentRemarks?.message}</span>
              </div>
              <div>
                <Button
                  variant="outlined"
                  endIcon={<Edit />}
                  className={classes.editButton}
                  onClick={e => {
                    onAddRemarks(
                      order.id,
                      order.orderCode,
                      order?.orderFulfillmentRemarks?.message,
                      order?.orderFulfillmentRemarks?.id
                    );
                    e.preventDefault();
                  }}
                ></Button>
              </div>
            </div>
          </Tooltip>
        </div>
      ) : (
        <Button
          variant="outlined"
          endIcon={<Edit />}
          onClick={e => {
            if (
              order?.orderFulfillmentRemarks &&
              order?.orderFulfillmentRemarks?.id
            ) {
              onAddRemarks(
                order.id,
                order.orderCode,
                "",
                order?.orderFulfillmentRemarks?.id
              );
            } else {
              onAddRemarks(order.id, order.orderCode, "");
            }
            e.preventDefault();
          }}
        >
          <div className={classes.remarksCellContent}>
            <span>Remarks</span>
          </div>
        </Button>
      )}
    </>
  );
};

export default RemarksCell;
